import React, { Component } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BlockUi from 'react-block-ui';
import Pagination from "react-js-pagination";
import * as lichSuTraThuongAction from './actions'
import DisplayRecordText from "../controls/_DisplayRecordText"
import { currentDate, formatDateTime, parseDatetime, getParam } from '../../lib/common'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { confirmAlert } from 'react-confirm-alert';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"

class LichSuTraThuong extends Component {
  constructor(props) {
    super(props);
    this.state = {
      objectId: 0,
      keyword: '',
      LoaiTraThuongId: '',
      per_page: 20,
      page: 1,
      total_record: 0,
      tuNgay: currentDate().startOf('month'),
      denNgay: currentDate(),
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  handleSelectChange = (selectedOption, name) => {
    switch (name) {
      case "TrangThai":
        this.setState({ LoaiTraThuongId: selectedOption.target.value })
        break;
      default:
        break;
    }
  }
  handleDateChange(e, name) {
    switch (name) {
      case "tuNgay":
        this.setState({ tuNgay: e });
        break;
      case "denNgay":
        this.setState({ denNgay: e });
        break;
    }
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  fetchList = () => {
    const { lichSuTraThuongListRequest } = this.props

    var requestData = {
      Keyword: this.state.keyword,
      Loai: this.state.LoaiTraThuongId,
      ObjectId: this.state.objectId,
      TuNgay: this.state.tuNgay != '' ? parseDatetime(this.state.tuNgay).unix() : '',
      DenNgay: this.state.denNgay != '' ? parseDatetime(this.state.denNgay).unix() : '',
      page: this.state.page,
      per_page: this.state.per_page
    };
    return lichSuTraThuongListRequest(requestData);
  }
  keyPress = (e) => {
    if (e.keyCode == 13) {
      this.search()
    }
  }
  search = () => {
    if (this.props.lichSuTraThuong.listRequesting) {
      return false;
    }
    return this.fetchList()
  }
  exportXls = () => {
    const { lichSuTraThuongExportXlsRequest } = this.props

    var requestData = {
      Keyword: this.state.keyword,
      Loai: this.state.LoaiTraThuongId,
      ObjectId: this.state.objectId,
      TuNgay: parseDatetime(this.state.tuNgay).unix(),
      DenNgay: parseDatetime(this.state.denNgay).unix(),
      page: this.state.page,
      per_page: this.state.per_page
    };
    return lichSuTraThuongExportXlsRequest(requestData, (data) => {
      var dataFile = new Blob([data], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExportOrder';
      var fileName = "lichSuTraThuong.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExportOrder";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
        link.remove();
      }
    });
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  RemovelichSuTraThuongItem = (TraThuongId) => {
    var requestData = {
      TraThuongId: TraThuongId
    }
    return this.props.lichSuTraThuongRemoveRequest(requestData, () => {
      setTimeout(() => {
        this.fetchList()
      }, 2000)
    });
  }
  HandleRemovelichSuTraThuongItem = (obj) => {
    if (!obj.TraThuongId) {
      return;
    }
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn muốn xóa trả thưởng của <span className="text-danger">{obj.TenDoiTuong}</span>, Việc này đồng nghĩa sẽ hoàn lại phần điểm của khách hàng?
              </p>
            <button className="text-danger" onClick={() => {
              this.RemovelichSuTraThuongItem(obj.TraThuongId)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  checkParams = (callback) => {
    const { location } = this.props
    let loai = getParam(location, "loai", 0)
    let objectId = getParam(location, "objectId", "")
    this.setState({
      LoaiTraThuongId: loai,
      objectId,
    }, callback)
  }
  componentDidMount() {
    this.checkParams(() => {
      this.fetchList();
    })
  }
  componentWillReceiveProps(nextProps) {
    
  }
  render() {
    const {
      handleSubmit,
      lichSuTraThuong: {
        listRequesting,
        list,
        errors,
        messages,
        isRequesting
      },
    } = this.props
    const {
      objectId,
      page,
      per_page
    } = this.state

    const isHidenFilter = objectId && objectId != ""
    const startIndex = (page > 0 ? page - 1 : 0) * per_page
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          {!isHidenFilter && (
            <div>
              <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
                <Row className="report-control">
                  <Col xs="12" sm="4" md="2" className="mb-2 p-2">
                    <InputGroup size="md">
                      <InputGroupAddon addonType="prepend">Loại</InputGroupAddon>
                      <select className="form-control" value={this.state.LoaiTraThuongId} onChange={e => this.handleSelectChange(e, "TrangThai")}>
                        <option value={0}>Loại khách hàng</option>
                        <option value={1}>Khách hàng</option>
                        <option value={2}>Đại lý</option>
                      </select>
                    </InputGroup>
                  </Col>
                  <Col md="2" sm="4" xs="6" className="mb-2 pt-2 pr-0 half-left">
                    <InputGroup size="md">
                      <span className="add_date_exs_span">Từ:</span>
                      <DatePicker
                        name="denNgay"
                        placeholder="đến ngày"
                        selected={this.state.tuNgay}
                        onChange={e => this.handleDateChange(e, "tuNgay")}
                        required className={"form-control add_date_exs_input"}
                        dateFormat="DD/MM/YYYY" />
                    </InputGroup>
                  </Col>
                  <Col md="2" sm="4" xs="6" className="mb-2 pt-2 pr-0 half-right">
                    <InputGroup size="md">
                      <span className="add_date_exs_span">Đến:</span>
                      <DatePicker
                        name="denNgay"
                        placeholder="đến ngày"
                        selected={this.state.denNgay}
                        onChange={e => this.handleDateChange(e, "denNgay")}
                        required className={"form-control add_date_exs_input"}
                        dateFormat="DD/MM/YYYY" />
                    </InputGroup>
                  </Col>
                  <Col sm="12" md="6" className="mb-2 p-2">
                    <InputGroup size="md">
                      <InputGroupAddon addonType="prepend" autoComplete="off" >Từ khóa</InputGroupAddon>
                      <Input name="keyword" placeholder="Tên khách hàng, nhân viên" value={this.state.keyword}
                        onKeyDown={e => this.keyPress(e)}
                        onChange={this.handleSearchChange.bind(this, "keyword")} />
                    </InputGroup>
                  </Col>
                </Row>
              </Collapsible>
            </div>
          )}
          {!isRequesting && !!errors.length && (
            <Errors errors={errors} />
          )}
          {!isRequesting && !!messages.length && (
            <Messages messages={messages} />
          )}
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="pull-left mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Làm mới</Button>
              <Button size="md" color="primary" className="mr-1" onClick={this.exportXls.bind(this, {})}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
            </div>
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="40" className="text-center">#</th>
                    <th scope="col" width="120" className="text-left">Ngày tạo</th>
                    <th scope="col" width="150" className="text-left">Nhân viên</th>
                    <th scope="col" width="150" className="text-left">Người trả thưởng</th>
                    <th scope="col" width="200" className="text-right">Số điểm trả</th>
                    <th scope="col" width="200" className="text-right">Số tiền trả</th>
                    <th scope="col" width="200" className="text-left">Ngày trả</th>
                    <th scope="col" className="text-left">Ghi chú</th>
                    <th scope="col" width="50" className="text-center">Xóa</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{startIndex + (idx + 1)}</td>
                        <td className="text-left">{(res.NgayTao != null && res.NgayTao != '') ? formatDateTime(res.NgayTao, "DD/MM/YYYY") : ''}</td>
                        <td className="text-left">{res.TenNhanVien}</td>
                        <td className="text-left">{res.TenDoiTuong}</td>
                        <td className="text-right font-weight-bold text-primary">{parseFloat(res.DiemTraThuong || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right font-weight-bold text-primary">{parseFloat(res.TienTraThuong || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-left">{(res.NgayTraThuong != null && res.NgayTraThuong != '') ? formatDateTime(res.NgayTraThuong, "DD/MM/YYYY") : ''}</td>
                        <td className="text-left">{res.GhiChu}</td>
                        <td className="text-center">
                          <ButtonExt className="mr-1 btn-sm"
                            color="danger"
                            iconClass="fa-trash"
                            displayText="Xóa"
                            btnClick={() => this.HandleRemovelichSuTraThuongItem(res)}
                            permission={BtnPermissions.TraThuongDiem.REMOVE} />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  lichSuTraThuong: state.lichSuTraThuong,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  lichSuTraThuongListRequest: lichSuTraThuongAction.lichSuTraThuongListRequest,
  lichSuTraThuongRemoveRequest: lichSuTraThuongAction.lichSuTraThuongRemoveRequest,
  lichSuTraThuongExportXlsRequest: lichSuTraThuongAction.lichSuTraThuongExportXlsRequest,
})(LichSuTraThuong)
const formed = reduxForm({
  form: 'lichSuTraThuong',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/LichSuTraThuong/LichSuTraThuong.js